var render = function render(){var _vm=this,_c=_vm._self._c;return _c('animated-button',{staticClass:"log-in button",attrs:{"title":_vm.fn.tr('Log in')},nativeOn:{"click":function($event){return _vm.openForm.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }